import React, { Component } from "react";
class Gorillaz extends Component {
  render() {
    return (
      <section className="col-7 nested">
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            In 1999, when flatmates musician Damon Albarn and artist Jamie
            Hewlett were watching MTV, they found that bands seemed manufactured
            and had ‘nothing of substance’. They decided to merge music and
            visual art by creating the virtual band Gorillaz. From its very
            creation, Gorillaz involved multiple media, including music, videos,
            advertisements, films, interviews, comics, podcasts, books, apps,
            games, quizzes, social media, radio, postcards, ‘telegrams’,
            magazines, VR, AR, and merchandise, to let their fans experience a
            coherent story.
            <br></br>
            <br></br>
            In this case study, I would like to present Gorillaz as a prime
            example of transmedia storytelling – detailing story elements,
            transformation of narrative with technology, and the experience that
            can be provided by current media landscape.
          </p>
        </div>

        <h2 className="large-spacer-top col-5">Story</h2>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            Gorillaz has over two decades worth of lore. The story of Gorillaz
            is divided into ‘phases’. Content is released in multiple media
            forms during and in-between these ‘phases’. The characters have aged
            appropriately over the past 20 years, making the story and its world
            more immersive.
          </p>
        </div>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>Characters</strong>{" "}
        </h3>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            The story follows virtual band members – Murdoc, 2D, Russel and
            Noodle – and their shenanigans, with several recurring side
            characters. The story also includes real-life personalities like
            live band members, collaborating artists, and celebrity cameos.
          </p>
        </div>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>Setting</strong>{" "}
        </h3>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            The world of Gorillaz involves real and made-up locations, including
            Kong Studios, a floating island, Plastic Beach, Mexico, North Korea,
            West London, Mumbai, and Dungeon Abbey, a made-up dungeon below the
            real Abbey Road Studios. The story world evokes magical realism.
          </p>
        </div>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>Tone</strong>{" "}
        </h3>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            The story itself is quite dark and subversive in its humour.
            Gorillaz are deemed as celebrities in our world, but their actions
            and happenstances in their lives are so over-the-top and random that
            it lets fans suspend their disbelief in favour of absurd storylines.
          </p>
        </div>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>Plot (loosely)</strong>{" "}
        </h3>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            10 years in, when the lore got too intricate and there was no linear
            record, Gorillaz released an ‘autobiography’, Rise Of The Ogre, that
            recounted the characters’ journey from their childhoods. Another 10
            years later, a fan-made sequel to the autobiography, Dawn Of The
            Ogre was released, filling in other gaps.
            <br></br>
            <br></br>
            The story of Gorillaz starts with Murdoc, a low-key evil bassist,
            assimilating members for his band. He recruits 2D, Russel and Noodle
            and inherits a haunted music studio, Kong Studios. From there, a lot
            happens over the years.
            <br></br>
            <br></br>
            Stories are scattered across the internet, ready for keen-eyed fans
            to discover.
          </p>
        </div>
        <div className="text-group">
          <ul className="text-list medium-spacer-bottom col-5">
            <li>
              The band has to relocate studios multiple times due to zombie
              infestations, arson, and demonic sinkholes. (Kong Studios, n.d.)
            </li>
            <li>
              Murdoc gives Queen’s speech in 2005 (Gorillaz to make Christmas
              speech, 2005).
            </li>
            <li>
              A recurring villain gets revealed as the rejected 5th horseman of
              the apocalypse (Jamie Hewlett Talks Gorillaz Part 1, 2011).
            </li>
            <li>
              Russel becomes a giant from ocean pollution and is declared the
              legendary North Korean Godzilla (Strauss, 2016).
            </li>
            <li>
              Noodle temporarily goes missing and is replaced by a cyborg
              version of herself ([AMA] We are the Gorillaz—Ask Us Anything!,
              2017).
            </li>
            <li>Murdoc spends multiple stints in prison (Smith, 2018).</li>
            <li>
              The band goes to space, beefs with aliens, and settles it, thanks
              to G-shock (Gorillaz x G-Shock - In Conversation, 2018).
            </li>
            <li>
              Portals open up from Gorillaz’s ‘song machine’ to collaborate with
              artists around the world (Gorillaz - Désolé ft. Fatoumata Diawara
              (Episode Two), 2020).
            </li>
            <li>
              The band starts a cult (Fear and loathing in LA: Gorillaz on
              cults, chaos and Cracker Island, 2023).
            </li>
          </ul>
        </div>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>Themes</strong>{" "}
        </h3>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            Over the years, creators Albarn and Hewlett have evolved as artists.
            Each album evokes a unique mix of musical genres along with lyrical
            and visual themes. Fans have come up with their interpretations for
            every album. Here is a brief outline of the themes each phase /
            album embodies -<br></br>
            <br></br>
            Gorillaz, 2001 – drugs, musical partnerships, manufactured music
            industry
            <br></br>
            <br></br>
            Demon Days, 2005 – blinding ego, colonialism, the world being an
            endless night
            <br></br>
            <br></br>
            Plastic Beach, 2010 – environmentalism, loneliness, consumerism
            <br></br>
            <br></br>
            Humanz, 2017 – emotional aftermath of political events, partying in
            dystopia
            <br></br>
            <br></br>
            The Now Now, 2018 – isolation, living in the moment, freedom
            <br></br>
            <br></br>
            Song Machine, 2020 – living in strange times, self-discovery, the
            year 2020 in general
            <br></br>
            <br></br>
            Cracker Island, 2023 – internet culture, metaverse, cults
          </p>
        </div>

        <h2 className="large-spacer-top col-5">Narrative and New media</h2>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            I have mentioned the different media utilized by Gorillaz to tell a
            story and allow fan interaction. Here, I would like to showcase that
            Gorillaz is an interesting case study in terms of transformation of
            narrative experience with technology. Gorillaz has been around since
            the dawn of global access to modern-day internet and social media.
            Since early 2000s, technology has evolved rapidly, and with it, new
            avenues of storytelling have been developed.
          </p>
        </div>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>Hypertext – websites to social media</strong>{" "}
        </h3>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            Hypertext allows for multiple realities, storylines, and concepts to
            exist simultaneously, letting users drive pace and decide story
            paths. From fan-interaction on the Gorillaz website and forums,
            Gorillaz has embraced the new media landscape by mediating
            fan-interaction on social media. Not only does Gorillaz material
            exist online and can be linked, but the band members themselves
            exist on the internet. Their online presence can be found on various
            social media.
          </p>
        </div>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>Virtual Personalities</strong>{" "}
        </h3>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            Gorillaz characters started as 2D beings in music videos. With
            experimental technology, the virtual band performed on stage on LED
            screens as holograms. Starting with Plastic Beach, 3D CGI animation
            was adopted, letting characters and real people co-exist in music
            videos. The band went on to be featured in live interviews using
            motion-capture technology. For their Humanz album, Gorillaz released
            360-degree VR videos on YouTube. Soon after, they released an AR app
            allowing fans take virtual tours of band members’ bedrooms to find
            easter eggs. This is a significant shift from their earlier days of
            releasing interactive tours on their website. Finally, Gorillaz
            announced the 'Humanz House Party’, an international scavenger hunt
            / music event / AR experience (Spencer, 2017). In 2022, they ‘live
            performed’ in Times Square, using Google’s location-based AR tool.
            (Stein, 2022).
          </p>
        </div>

        <h2 className="large-spacer-top col-5">The Experience</h2>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            The YouTube video – “Trying To Explain The Gorillaz Lore” (2021) is
            how I became aware of the Gorillaz story. Before that, I was just a
            fan of their music. The storytelling experience of Gorillaz is one
            of a kind. Even though there is a start and an end, the timeline is
            strung together by fans through experiencing the story over the
            years or by sifting through the internet. The Gorillaz website has
            been through many versions so some information is unavailable.
            However, nothing is truly lost on the internet. The story has been
            retold multiple times by fans on various forums, fan sites, and
            social media. Additional data can be found in web archives.
          </p>
        </div>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>Interactivity</strong>{" "}
        </h3>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            (Jager & Kim, 2015) highlight that in new media art,
            “[interactivity] is assigned a temporal dimension due to the
            character of works of art based on a temporally expanded interaction
            space. Therefore, a status change of the same interface as a medium
            relies on interaction actively explored by the user.” To understand
            interactivity offered by Gorillaz, we must keep the spatial and
            temporal contexts in mind. Spatially, Gorillaz affords an infinite
            navigable space to users. However, websites keep updating, and new
            technology keeps emerging, allowing users to explore the story in
            different temporal contexts.
          </p>
        </div>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>Immersion</strong>{" "}
        </h3>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            (Fleischmann & Strauss, 2015) expand on immersion, stating that
            “interactive storytelling offers the observer an individually
            tailored encounter, where the user is navigating the story.” Even
            though the story is same, interaction of each user may lead to a
            personalized experience based on the user’s context and the order or
            pace of navigation.
            <br></br>
            <br></br>
            In the same article, the authors argue that “the core of the
            interactive plot is not about the communication of one single
            reality, but lies in differing viewpoints and positions based on
            hypertext structures and generative processes.” Hypertext
            facilitates immersion.
            <br></br>
            <br></br>
            While the story itself is highly immersive, it does not get
            cumbersome for users as the story has multiple entry points and
            exploration is entirely up to user, offering broad agency.
          </p>
        </div>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>Agency</strong>{" "}
        </h3>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            Researchers (Venturini, Jacomy, Meunier, & Latour, 2017) suggest
            that “inviting us to navigate through different scales of actions,
            digital methods have profound political implications. Alongside the
            transformation of digital inscriptions, another operation is taking
            place: the crafting of alternative narratives about social life.” By
            analysing themes of each phase of the Gorillaz discography (see
            section 2.5), one may argue that Gorillaz has presented a narrative
            in the form of an alternate reality, but a reality similar enough to
            our world to invite a political discourse on the internet.
          </p>
        </div>

        <h2 className="large-spacer-top col-5">Conclusion</h2>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            (Juzwiak, 2001) may argue that Gorillaz’s “act” is “a smarmy,
            promotional gimmick”, but Gorillaz’s consistent innovation to make
            user interaction a unique experience has solidified them as a pop
            cultural phenomenon of their generation. In conclusion, Gorillaz has
            created a unique story experience by providing their fans with a
            huge library of media content that can be experienced at users’ own
            pace and interest.
          </p>
        </div>

        <h2 className="large-spacer-top col-5">Future Work</h2>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            Future work could focus on understanding the preconditions that
            might support sustained narrative exchange in context of internet
            media culture. It would also be interesting to explore users’ memory
            retention for long form multi-media content.
          </p>
        </div>

        <h2 className="large-spacer-top col-5">References</h2>
        <br></br>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom small-spacer-top">
            [AMA] We are the Gorillaz - Ask Us Anything! (2017).
            https://www.reddit.com/r/Music/comments/682hwf/comment/dgv57f7/
            <br></br>
            <br></br>
            Fear and loathing in LA: Gorillaz on cults, chaos and Cracker
            Island. (2023, January 26).
            https://www.rollingstone.co.uk/music/features/fear-and-loathing-in-la-gorillaz-on-cults-chaos-and-cracker-island-26178/
            <br></br>
            <br></br>
            Fleischmann, M., & Strauss, W. (2015). Staging of the thinking
            space: From immersion to performative presence. In U. Seifert, J. H.
            <br></br>
            <br></br>
            Kim & A. Moore (Eds.), Paradoxes of interactivity (pp. 266-281).
            transcript Verlag. https://doi.org/10.1515/9783839408421-013
            <br></br>
            <br></br>
            Gorillaz - Désolé ft. Fatoumata Diawara (Episode Two). (2020,
            February 27).
            https://www.youtube.com/watch?v=ZLKZKmdZEjM&list=PLtKoi37ubAW2llPOBURWbOS7tI9grUpte&index=22
            <br></br>
            <br></br>
            Gorillaz to make Christmas speech (2005, December 22).
            http://news.bbc.co.uk/2/hi/entertainment/4552000.stm
            <br></br>
            <br></br>
            Gorillaz x G-Shock - In Conversation. (2018, November 15).
            https://www.youtube.com/watch?v=7jfZ6zLkWF0&list=PLtKoi37ubAW0pDD6F1Jgnyh5S3ENEOAjp
            <br></br>
            <br></br>
            Jäger, L., & Kim, J. H. (2015). Transparency and opacity: Interface
            technology of mediation in new media art. In U. Seifert, J. H. Kim &
            A. Moore (Eds.), Paradoxes of interactivity (pp. 44-61). transcript
            Verlag. https://doi.org/10.1515/9783839408421-003
            <br></br>
            <br></br>
            Jamie Hewlett Talks Gorillaz Part 1 (2011, January 11).
            https://www.clashmusic.com/features/jamie-hewlett-talks-gorillaz-part-1/
            <br></br>
            <br></br>
            Juzwiak, R. (2001, May 31). Pitchfork.
            https://pitchfork.com/reviews/albums/3524-gorillaz/
            <br></br>
            <br></br>
            Kong Studios (n.d.). https://gorillaz.fandom.com/wiki/Kong_Studios
            <br></br>
            <br></br>
            Smith, T. (2018, July 17). Gorillaz: Murdoc hits back at 2D in
            exclusive prison interview.
            https://www.nme.com/blogs/nme-blogs/gorillaz-exclusive-murdoc-hits-back-2d-wormwood-scrubs-cell-2354976
            <br></br>
            <br></br>
            Spencer, S. (2017, October 25) The Evolution Of Gorillaz.
            https://www.shots.net/news/view/94339-the-evolution-of-gorillaz
            <br></br>
            <br></br>
            Stein, S. (2022, December 14) Gorillaz Are Performing An AR Concert
            With Google Tech.
            https://www.shots.net/news/view/94339-the-evolution-of-gorillaz
            <br></br>
            <br></br>
            Strauss, M. (2016, October 7) Gorillaz Share New Visual Story “The
            Book of Russel”: Watch. Trying To Explain The Gorillaz Lore (2021,
            August 24). https://www.youtube.com/watch?v=UZ4PUYsd0vQ&t=33s
            <br></br>
            <br></br>
            Venturini, T., Jacomy, M., Meunier, A., & Latour, B. (2017). An
            unexpected journey: A few lessons from sciences Po médialab’s
            experience. Big Data & Society, 4(2).
            https://doi.org/10.1177/2053951717720949
          </p>
        </div>
      </section>
    );
  }
}

export default Gorillaz;
